var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('PremiacaoNivel', {
    attrs: {
      "premiados-nivel": _vm.premiados.nivel1,
      "nivel": 1
    }
  }), _c('PremiacaoNivel', {
    attrs: {
      "premiados-nivel": _vm.premiados.nivel2,
      "nivel": 2
    }
  }), _c('PremiacaoNivel', {
    attrs: {
      "premiados-nivel": _vm.premiados.nivel3,
      "nivel": 3
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };